export const getIsWas = (chooseenYear: string) => {
  const currentYear = new Date().getFullYear();

  return currentYear === parseInt(chooseenYear, 0) ? "is" : "was";
};
